import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth/auth.service';
import { Translators } from 'src/app/services/shared/translators.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config/app.config';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { ConfigAppService } from '@services/shared/config-app.service';
import { AvisoSuspensionService } from '@services/shared/aviso-suspension.service';
import { SpinnerService } from '@services/shared/spinner.service';

const googleClientId = environment.googleClientId;
const redirectUri = environment.redirectUri;

@Component({
  selector: 'app-auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  showPasswordLogin: boolean = false;
  googleLoginActivo = true;

  constructor(
    private authservice: AuthService,
    private translatorService: Translators,
    @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
    private router: Router,
    private configAppService: ConfigAppService,
    private avisoSuspension: AvisoSuspensionService,
    public spinnerService: SpinnerService,
  ) {
    this.createFormLogin();
  }

  async ngOnInit() {
    this.googleLoginActivo = await this.configAppService.getGoogleLogin();
    // En el login todavia no hay usuario: el cartel es para quien llega.
    await this.avisoSuspension.mostrarSiCorresponde({ soloAfiliados: false });
  }

  createFormLogin() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(10),
      ]),
    });
  }

  get emailAccess() {
    return (
      this.loginForm.get('email').invalid &&
      this.loginForm.get('email').touched
    );
  }

  get passwordAccess() {
    return (
      this.loginForm.get('password').invalid &&
      this.loginForm.get('password').touched
    );
  }

  async login() {
    if (this.loginForm.invalid) {
      return Object.values(this.loginForm.controls).forEach((control) => {
        control.markAsTouched();
      });
    }

    this.spinnerService.show('Espere...');
    try {
      await this.authservice.login(
        this.loginForm.value.email,
        this.loginForm.value.password,
      );
    } finally {
      this.spinnerService.hide();
    }
  }

  private buildGoogleOAuthUrl(): string {
    const params = new URLSearchParams({
      client_id: googleClientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: 'openid email profile',
      prompt: 'select_account',
      access_type: 'offline',
      include_granted_scopes: 'true',
    });

    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  }

  async loginWithGoogle() {
    const url = this.buildGoogleOAuthUrl();
    window.location.href = url;
  }
}
